<template>
  <div>
    <div class="modal-title">{{ $t('tour_change_arrival_and_stay') }}</div>
    <div class="modal-content">
      <div class="text-sm text-red">※後の行程も自動で変更される場合があります。</div>
      <p class="text-xs text-label mt-4">{{ $t('tour_residence_time_label') }}</p>
      <time-select v-model="time" />
    </div>
    <div class="modal-button">
      <a class="button-primary block" @click="callback(target.destination, time)">{{ $t('tour_setting') }}</a>
    </div>
  </div>
</template>

<script>
import TimeSelect from "./TimeSelect"
import moment from 'moment-timezone'
moment.tz.setDefault('Asia/Tokyo')

export default {
  components: {
    TimeSelect
  },
  props: {
    target: {
      type: Object,
      required: true
    },
    callback: {
      type: Function,
      required: true
    }
  },
  data () {
    return {
      time: this.target.destination.visit,
      isStay: this.target.destination.isStay
    }
  },
  watch: {
    target: function (val) {
      this.time = val.destination.visit,
      this.isStay = this.target.destination.isStay ? true : false
    }
  },
  methods: {
    calcVisit() {
      const visitTime = this.checkoutTime.diff(this.checkinTime, 'minutes', false)
      return visitTime
    }
  }
}
</script>
